import { render, staticRenderFns } from "./TargetWallet.vue?vue&type=template&id=6f7dac8a&"
import script from "./TargetWallet.vue?vue&type=script&lang=js&"
export * from "./TargetWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports